
import PlatinumText from '~/components/Icons/Seals/PlatinumText.vue'
import SilverText from '~/components/Icons/Seals/SilverText.vue'
import GoldText from '~/components/Icons/Seals/GoldText.vue'
import HsrText from '~/components/Icons/Seals/HsrText.vue'

const SEAL_TEXT_MAP = {
  hsr: {
    text: HsrText,
    color: 'rgba(171,205,232,.7)',
    classes: 'h-[3.75rem] w-36 md:h-[6.2rem] md:w-56 top-[57%] md:top-[60%]',
  },
  platinum: {
    text: PlatinumText,
    color: 'rgba(120,119,127,.45)',
    classes: 'h-2 w-16 md:h-3 md:w-24 top-[57%]',
  },
  silver: {
    text: SilverText,
    color: 'rgba(178,178,178,.45)',
    classes: 'h-2 w-12 md:h-3 md:w-16 top-[57%]',
  },
  gold: {
    text: GoldText,
    color: 'rgba(242,232,188,.45)',
    classes: 'h-2 w-12 md:h-3 md:w-16 top-[57%]',
  },
}

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    blurClasses: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      selectedSeal: {},
      selector: null,
    }
  },
  watch: {
    options: {
      handler(newVal, oldVal) {
        if (newVal.animateCycle) {
          this.$gsap.delayedCall(
            1,
            () => (this.selectedSeal = SEAL_TEXT_MAP[newVal.next])
          )
          this.startAnimation(oldVal.next, newVal.next)
        }
      },
    },
  },
  mounted() {
    // set scope
    this.selector = this.$gsap.utils.selector(this.$parent.$el)

    this.$nextTick(() => {
      this.initialReveal()
      this.selectedSeal = this.name ? SEAL_TEXT_MAP[this.name] : {}
    })
  },
  methods: {
    initialReveal() {
      this.setSealTransform()
      if (this.name === 'hsr') this.initHsr(SEAL_TEXT_MAP[this.name]?.color)
      else this.initDefault(SEAL_TEXT_MAP[this.name]?.color)
    },
    startAnimation(prev, next) {
      // determine which animation sequence is called
      switch (true) {
        case prev === 'hsr' && next === 'hsr':
          this.hsrToHsr(SEAL_TEXT_MAP[next]?.color)
          break
        case prev === 'hsr' && next !== 'hsr':
          this.hsrToDefault(SEAL_TEXT_MAP[next]?.color)
          break
        case prev !== 'hsr' && next === 'hsr':
          this.defaultToHsr(SEAL_TEXT_MAP[next]?.color)
          break
        case prev !== 'hsr' && next !== 'hsr':
          this.defaultToDefault(SEAL_TEXT_MAP[next]?.color)
          break
        default:
      }
    },

    // animation sequence
    setSealTransform() {
      // set initial transform css for seal lines
      // recomended to set styles through gsap to avoid cross browser interference
      this.$gsap.set('.circle-seal', {
        transformOrigin: 'center',
      })
    },
    rotateSeal() {
      // rotate svg
      // rotate logo oposite way to balance
      return this.$gsap
        .timeline()
        .fromTo(
          this.selector('.loader__seal'),
          { rotate: '0deg' },
          { rotate: '360deg', delay: 0.3, duration: 2 },
          0
        )
        .fromTo(
          this.selector('.loader__logo'),
          { rotate: '0deg' },
          { rotate: '-360deg', delay: 0.3, duration: 2 },
          0
        )
    },
    resetSealName() {
      return this.$gsap
        .timeline()
        .to(
          this.selector('.loader__logo-text'),
          { opacity: 0, duration: 0.1 },
          0
        )
        .to(
          this.selector('.loader__logo'),
          { duration: 0.4, y: 0, ease: 'easeOut' },
          0
        )
    },
    changeSealName(isDefault, color) {
      return this.$gsap
        .timeline()
        .to(this.selector('.loader__seal'), {
          backgroundColor: color,
          duration: 0.3,
        })
        .to(this.selector('.loader__logo'), {
          duration: 0.6,
          y: isDefault ? -10 : -20,
        })
        .to(this.selector('.loader__logo-text'), { opacity: 1, duration: 0.2 })
    },
    initDefault(color) {
      // transition: initial -> default
      // this.setSealTransform()
      this.$gsap.set(
        this.selector('.loader__circle-1'),
        { drawSVG: '0', rotate: '386deg' },
        1
      )
      this.$gsap.set(
        this.selector('.loader__circle-2'),
        { drawSVG: '0', rotate: '281deg' },
        0.9
      )
      this.$gsap.set(
        this.selector('.loader__circle-3'),
        { drawSVG: '0', rotate: '386deg' },
        0.9
      )
      this.$gsap.set(
        this.selector('.loader__circle-4'),
        { drawSVG: '0', rotate: '116deg' },
        0.8
      )
      this.$gsap.set(
        this.selector('.loader__circle-5'),
        { drawSVG: '0', rotate: '71deg' },
        0.7
      )
      this.$gsap.set(
        this.selector('.loader__circle-6'),
        { drawSVG: '0', rotate: '146deg' },
        0.7
      )
      this.$gsap.set(
        this.selector('.loader__circle-7'),
        { drawSVG: '0', rotate: '251deg' },
        0.6
      )
      this.$gsap.set(
        this.selector('.loader__circle-8'),
        { drawSVG: '0', rotate: '326deg' },
        {
          drawSVG: '20.8%',
          rotate: '326deg',
          duration: 0.6,
          ease: 'easeOut',
        },
        0.6
      )
      this.$gsap.set(
        this.selector('.loader__circle-9'),
        { drawSVG: '0', rotate: '461deg' },
        {
          drawSVG: '24.9%',
          rotate: '461deg',
          duration: 0.5,
          ease: 'easeOut',
        },
        0.5
      )
      this.$gsap.set(
        this.selector('.loader__circle-10'),
        { drawSVG: '0', rotate: '281deg' },
        {
          drawSVG: '24.9%',
          rotate: '281deg',
          duration: 0.5,
          ease: 'easeOut',
        },
        0.5
      )

      this.$gsap
        .timeline()
        .fromTo(
          this.selector('.loader__seal'),
          { autoAlpha: 0 },
          { autoAlpha: 1, duration: 0.5, delay: 0.1 },
          0.3
        )
        .to(
          this.selector('.loader__seal'),
          { rotate: '360deg', duration: 1.5 },
          0.5
        )
        .to(
          this.selector('.loader__logo-text'),
          { opacity: 0, duration: 0.6 },
          0.05
        )

        .to(
          this.selector('.loader__circle-1'),
          { drawSVG: '100%', rotate: '386deg', duration: 1, ease: 'easeOut' },
          1
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '21%', rotate: '281deg', duration: 0.9, ease: 'easeOut' },
          0.9
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '17%', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.9
        )
        .to(
          this.selector('.loader__circle-4'),
          { drawSVG: '21%', rotate: '116deg', duration: 0.8, ease: 'easeOut' },
          0.8
        )
        .to(
          this.selector('.loader__circle-5'),
          { drawSVG: '12.5%', rotate: '71deg', duration: 0.7, ease: 'easeOut' },
          0.7
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '21%', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.7
        )
        .to(
          this.selector('.loader__circle-7'),
          {
            drawSVG: '12.5%',
            rotate: '251deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.6
        )
        .to(
          this.selector('.loader__circle-8'),
          {
            drawSVG: '20.8%',
            rotate: '326deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.6
        )
        .to(
          this.selector('.loader__circle-9'),
          {
            drawSVG: '24.9%',
            rotate: '461deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          {
            drawSVG: '24.9%',
            rotate: '281deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )

        .to(this.selector('.loader__seal'), {
          backgroundColor: color,
          duration: 0.3,
        })
        .fromTo(
          this.selector('.seal__blur'),
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.6,
          }
        )
        .fromTo(
          this.selector('.loader__logo'),
          { opacity: 0 },
          { opacity: 1, duration: 0.6, y: -10 }
        )
        .fromTo(
          this.selector('.loader__logo-text'),
          { opacity: 0 },
          { opacity: 1, duration: 0.6 }
        )
    },
    initHsr(color) {
      // transition: initial -> hsr
      // this.setSealTransform()
      this.$gsap.set(
        this.selector('.loader__circle-1'),
        { drawSVG: '0%', rotate: '354deg' },
        0.5
      )
      this.$gsap.set(
        this.selector('.loader__circle-2'),
        { drawSVG: '0%', rotate: '340deg' },
        0.5
      )
      this.$gsap.set(
        this.selector('.loader__circle-3'),
        { drawSVG: '0', rotate: '386deg' },
        0.9
      )
      this.$gsap.set(
        this.selector('.loader__circle-4'),
        {
          drawSVG: '0%',
          rotate: '191deg',
        },
        0.5
      )
      this.$gsap.set(
        this.selector('.loader__circle-5'),
        {
          drawSVG: '0%',
          rotate: '40deg',
        },
        0.5
      )
      this.$gsap.set(
        this.selector('.loader__circle-6'),
        { drawSVG: '0', rotate: '146deg' },
        0.7
      )
      this.$gsap.set(
        this.selector('.loader__circle-7'),
        { drawSVG: '0', rotate: '251deg' },
        0.6
      )
      this.$gsap.set(
        this.selector('.loader__circle-8'),
        { drawSVG: '0', rotate: '326deg' },
        0.6
      )
      this.$gsap.set(this.selector('.loader__circle-9'), {
        drawSVG: '0',
        rotate: '461deg',
      })
      this.$gsap.set(
        this.selector('.loader__circle-10'),
        { drawSVG: '0', rotate: '281deg' },
        0.5
      )

      this.$gsap
        .timeline()
        .fromTo(
          this.selector('.loader__seal'),
          { autoAlpha: 0 },
          { autoAlpha: 1, duration: 0.5, delay: 0.1 },
          0.3
        )
        .to(
          this.selector('.loader__seal'),
          { rotate: '360deg', duration: 1.5 },
          0.5
        )
        .to(
          this.selector('.loader__logo-text'),
          { opacity: 0, duration: 0.6 },
          0.05
        )

        .to(
          this.selector('.loader__circle-1'),
          {
            drawSVG: '76%',
            rotate: '354deg',
            duration: 1,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '21%', rotate: '340deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '0', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.9
        )
        .to(
          this.selector('.loader__circle-4'),

          {
            drawSVG: '25%',
            rotate: '191deg',
            duration: 0.8,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-5'),

          {
            drawSVG: '47%',
            rotate: '40deg',
            duration: 0.7,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '0', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.7
        )
        .to(
          this.selector('.loader__circle-7'),
          {
            drawSVG: '0',
            rotate: '251deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.6
        )
        .to(
          this.selector('.loader__circle-8'),
          {
            drawSVG: '0',
            rotate: '326deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.6
        )
        .to(
          this.selector('.loader__circle-9'),
          {
            drawSVG: '0',
            rotate: '461deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          {
            drawSVG: '0',
            rotate: '281deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )

        .to(this.selector('.loader__seal'), {
          backgroundColor: color,
          duration: 0.3,
        })
        .fromTo(
          this.selector('.seal__blur'),
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.6,
          }
        )
        .fromTo(
          this.selector('.loader__logo'),
          { opacity: 0 },
          { opacity: 1, duration: 0.6, y: -20 }
        )
        .fromTo(
          this.selector('.loader__logo-text'),
          { opacity: 0 },
          { opacity: 1, duration: 0.6 }
        )
    },
    defaultToDefault(color) {
      // SEQUENCE 1
      // transition: initial -> default

      this.$gsap
        .timeline()
        .add(this.resetSealName())
        .add(this.rotateSeal(), 0)
        .add(this.changeSealName(true, color))

      this.$gsap
        .timeline({
          yoyoEase: true,
          onUpdate() {
            // once anim is about halway, reverse it
            if (this.progress() > 0.7) this.reverse()
          },
        })
        .to(
          this.selector('.loader__circle-1'),
          { drawSVG: '100%', rotate: '386deg' },
          {
            drawSVG: '100%',
            rotate: '386deg',
            duration: 1,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '10%', rotate: '281deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '8%', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-4'),
          { drawSVG: '0%', rotate: '116deg', duration: 0.8, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-5'),
          { drawSVG: '0%', rotate: '71deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '0%', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-7'),
          { drawSVG: '8%', rotate: '251deg', duration: 0.6, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-8'),
          { drawSVG: '0%', rotate: '326deg', duration: 0.6, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-9'),
          { drawSVG: '5%', rotate: '461deg', duration: 0.5, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          { drawSVG: '10%', rotate: '281deg', duration: 0.5, ease: 'easeOut' },
          0.5
        )
    },
    defaultToHsr(color) {
      // SEQUENCE 2
      // transition: default -> hsr

      this.$gsap
        .timeline()
        .add(this.resetSealName())
        .add(this.rotateSeal(), 0)
        .add(this.changeSealName(false, color))

      this.$gsap
        .timeline()
        .to(
          this.selector('.loader__circle-1'),
          {
            drawSVG: '76%',
            rotate: '354deg',
            duration: 1,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '21%', rotate: '340deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '0%', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-4'),

          {
            drawSVG: '25%',
            rotate: '191deg',
            duration: 0.8,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-5'),

          {
            drawSVG: '47%',
            rotate: '40deg',
            duration: 0.7,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '0%', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-7'),
          { drawSVG: '0%', rotate: '251deg', duration: 0.6, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-8'),
          { drawSVG: '0%', rotate: '326deg', duration: 0.6, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-9'),
          { drawSVG: '0%', rotate: '461deg', duration: 0.5, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          { drawSVG: '0%', rotate: '281deg', duration: 0.5, ease: 'easeOut' },
          0.5
        )
    },
    hsrToDefault(color) {
      // SEQUENCE 3
      // transition: hsr -> default

      this.$gsap
        .timeline()
        .add(this.resetSealName())
        .add(this.rotateSeal(), 0)
        .add(this.changeSealName(true, color))

      this.$gsap
        .timeline()
        .to(
          this.selector('.loader__circle-1'),
          {
            drawSVG: ' 100%',
            rotate: '386deg',
            duration: 1,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '21%', rotate: '281deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '17%', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-4'),
          { drawSVG: '21%', rotate: '116deg', duration: 0.8, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-5'),
          { drawSVG: '12.5%', rotate: '71deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '21%', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-7'),
          {
            drawSVG: '12.5%',
            rotate: '251deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-8'),
          {
            drawSVG: '20.8%',
            rotate: '326deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-9'),
          {
            drawSVG: '24.9%',
            rotate: '461deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          {
            drawSVG: '24.9%',
            rotate: '281deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
    },
    hsrToHsr(color) {
      // SEQUENCE 4
      // transition: hsr -> hsr

      this.$gsap
        .timeline()
        .add(this.resetSealName())
        .add(this.rotateSeal(), 0)
        .add(this.changeSealName(false, color))

      this.$gsap
        .timeline({
          yoyoEase: true,
          onUpdate() {
            // once anim is about halway, reverse it
            if (this.progress() > 0.7) this.reverse()
          },
        })
        .to(
          this.selector('.loader__circle-1'),
          {
            drawSVG: ' 76%',
            rotate: '354deg',
            duration: 1,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-2'),
          { drawSVG: '10%', rotate: '340deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-3'),
          { drawSVG: '0', rotate: '386deg', duration: 0.9, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-4'),
          { drawSVG: '8%', rotate: '191deg', duration: 0.8, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-5'),
          { drawSVG: '0', rotate: '40deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-6'),
          { drawSVG: '0', rotate: '146deg', duration: 0.7, ease: 'easeOut' },
          0.5
        )
        .to(
          this.selector('.loader__circle-7'),
          {
            drawSVG: '0',
            rotate: '251deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-8'),
          {
            drawSVG: '0',
            rotate: '326deg',
            duration: 0.6,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-9'),
          {
            drawSVG: '0',
            rotate: '461deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
        .to(
          this.selector('.loader__circle-10'),
          {
            drawSVG: '0',
            rotate: '281deg',
            duration: 0.5,
            ease: 'easeOut',
          },
          0.5
        )
    },
  },
}
